import { InputNumber as InputNumberBase, InputNumberProps } from 'antd';
import { ElementRef, forwardRef } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

interface IInputNumberWrapProps extends InputNumberProps {
  field?: ControllerRenderProps<any, any>;
}

export const InputNumber = forwardRef<
  ElementRef<typeof InputNumberBase>,
  IInputNumberWrapProps
>(
  ({ className, field, ...props }, ref) => {
    const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const specialCharRegex = new RegExp('[0-9]');
      const pressedKey = String.fromCharCode(
        !e.charCode ? e.which : e.charCode,
      );

      if (!specialCharRegex.test(pressedKey) || pressedKey === ' ') {
        e.preventDefault();
        return;
      }
    };

    return (
      <InputNumberBase
        ref={ref}
        className={className}
        onKeyPress={onKeyPress}
        inputMode='none'
        controls={false}
        pattern='[0-9]*'
        {...field}
        {...props}
      />
    );
  },
);
